'use strict';

var dialog = require('../../dialog'),
	util = require('../../util'),
	addToCart = require('./addToCart'),
	linchpin = require('int_googletagmanager/linchpin/product');

/**
 * @function
 * @description Checks product inventory in the selected store
 * @param {String} storeID The ID of the store to check product inventory
 */
var checkProductInventory = function (storeID) {
	var $pdpForm = $('.pdpForm');
	// Update product quantity to 1
	$pdpForm.find('input[name="Quantity"]').first().val(1);
	var qty = $pdpForm.find('input[name="Quantity"]').first().val();
	// Prepare parameters
	var params = {
		format: 'ajax',
		productQty: isNaN(qty) ? '1' : qty,
		productID: $pdpForm.find('input[name="pid"]').first().val(),
		storeID: storeID
	};
	var url = util.appendParamsToUrl(Urls.checkProductInventory, params);
	var options = {
		url: url,
		type: 'POST'
	};
	$.ajax(options).done(function (data) {
		if (storeID !== '') {
			// Load content
			$('#inventory-result-section').html(data);

			// Event handler for Order Click & Collect button
			if ($pdpForm.find('.add-to-cart').length) {
				$('#order-via-click-and-collect').on('click', function () {
					$pdpForm.find('.add-to-cart').trigger('click');
				});
			} else {
				addToCart($('form.cacAddToCart'), false);
			}

			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.triggerCheckStoreStockEvent();
			}
		} else {
			$('#inventory-result-section').html('');
		}
	});
};

/**
 * @function
 * @description Binds the click event to the Check Store Stock button
 *              for the check-store-stock handling
 */
var checkStoreStock = function () {
	$('#check-store-stock').on('click', function () {
		var url = util.appendParamsToUrl(Urls.getStoresByLocale);
		// Open dialog with the list of available stores
		dialog.open({
			url: url,
			options: {
				title: $(this).attr('title'),
				dialogClass: 'check-store-dialog',
				open: function () {
					// on change check product availability in the store
					var $storeList = $('[name$="_storesList"]');
					$($storeList).on('change', function () {
						checkProductInventory($(this).val());
					});
					// if a default is set, check store availability
					if ($storeList.val().length > 0) {
						checkProductInventory($storeList.val());
					}

					// Fix dialog positioning issue on Iphone
					var userAgent = (navigator.userAgent).toLowerCase();
					if (userAgent.indexOf('iphone') !== -1) {
						window.scrollTo(0, 400 - ($(window).height() - 150) / 2);
					}
				},
				buttons: []
			}
		});
	});
};

module.exports = checkStoreStock;
